module.exports = __webpack_public_path__ + "static/media/SerieSV.9a0e6556.pdf";